// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__2TmdD","label":"LabeledBox_label__2UZ6S"};